import { Loading } from 'carbon-components-react';
import Breadcrumbs from './breadcrumbs/Breadcrumbs';
import MainHeaderComponent from './main-header/main-header.component';
import MainMenuComponent from './menu/main-menu/main-menu.component';

export default function PageLayout({
  children,
  className,
  breadcrumbs,
  title,
  isLoading = false,
}) {
  return (
    <div className="no-print">
      <MainHeaderComponent />

      <div className={`page-container ${className}`}>
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '500px',
            }}
          >
            <Loading description="Loading..." />
          </div>
        ) : (
          <>
            <header className="mb-20">
              {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
              <MainMenuComponent />
              <hr className="grey-hr mt-10 mb-10" />

              {typeof title === 'string' && <h1 className="h-20">{title}</h1>}
              {typeof title === 'object' && title}
            </header>

            <main>{children}</main>
          </>
        )}
      </div>
    </div>
  );
}
